import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { EPaymentModalType } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.types';
import { BuySubscriptionActions } from 'reactApp/modules/buySubscription/buySubscription.module';
import { FastCheckoutActions } from 'reactApp/modules/fastCheckout/fastCheckout.actions';

export const usePaymentCallbacks = ({ type }) => {
    const dispatch = useDispatch();

    const actions = useMemo(() => {
        return type === EPaymentModalType.trial
            ? {
                  buy: FastCheckoutActions.buySubscription,
                  reset: FastCheckoutActions.reset,
              }
            : {
                  buy: BuySubscriptionActions.buySubscription,
                  reset: BuySubscriptionActions.resetLink,
              };
    }, [type]);

    const handleBuySubscription = useCallback(
        (productId: string) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            dispatch(actions.buy({ id: productId, isMobile: false, isVKPay: true }));
        },
        [actions, dispatch]
    );

    const handleResetSubscriptions = useCallback(
        (productId: string) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            dispatch(actions.reset(productId));
        },
        [actions, dispatch]
    );

    return {
        buySubscription: handleBuySubscription,
        resetLink: handleResetSubscriptions,
    };
};
